import { Condition } from '@app/promotionHub/shared/types/Condition';
import { AwardingConditions } from '@core/models/bonus/AwardingConditions';
import { BonusKind } from '@core/models/bonus/Bonus';
import { WelcomeBonus } from '@core/models/bonus/WelcomeBonus';
import { PromoHubActionButton } from '@src/app/promotionHub/shared/types/PromoHubActionButton';

export type Promotion = {
    kind?: BonusKind;
    promotionId: number | string;
    promotionInstanceId?: string;
    title: string;
    description?: string;
    type?: number;
    status: PromotionStatus;
    startDate?: Date;
    expirationDate: Date | null;
    conditions: Condition[];
    bonus: PromotionBonus;
    optInCode?: string;
    image?: string;
    bonusSummaryTitle?: string;
    bonusValue?: string;
    welcomeBonuses?: WelcomeBonus[];
    qualificationProgress?: PromotionQualification[];
    optInDate?: Date;
    promoActionButton?: PromoHubActionButton;
    termsAndConditionsUrl?: string;
    isCalendarPromotion?: boolean;
    isManualPromotion?: boolean;
    isCashbackPromotion?: boolean;
    isMultiConditionPromotion?: boolean;
};

export type PromotionBonus = {
    name: string;
    bonusAmount?: number;
    conditions?: Condition[];
    type: PromotionBonusType | null;
    expirationDate?: Date;
    priority?: number;
    acceptedDate?: Date;
    awardingConditions?: AwardingConditions[];
    rewardType?: string;
};

export const PromotionBonusType = {
    Casino: 'Casino',
    Sportsbook: 'Sportsbook',
    FreeBet: 'FreeBet',
    External: 'External',
    WelcomeOffer: 'WelcomeOffer',
    Honey: 'Honey',
} as const;
export type PromotionBonusType = typeof PromotionBonusType[keyof typeof PromotionBonusType];

export const PromotionStatus = {
    Available: 'Available',
    InProgress: 'InProgress',
    Completed: 'Completed',
    History: 'History',
    Expired: 'Expired',
    Unspecified: 'Unspecified',
};
export type PromotionStatus = typeof PromotionStatus[keyof typeof PromotionStatus];

export type PromotionQualification = {
    type: PromotionQualificationType;
    amountRequired: number;
    amountFulfilled: number;
    phase: number | undefined;
    title: string;
    isQualificationMet: boolean;
    isCurrency?: boolean;
    stakeMultiplier?: number;
    waitingForBetsToSettle?: boolean;
};

export const PromotionQualificationType = {
    DepositMoney: 'DepositMoney',
    DepositNumber: 'DepositNumber',
    WagerMoney: 'WagerMoney',
    WagerBets: 'WagerBets',
    CasinoMoney: 'CasinoMoney',
    CasinoGames: 'CasinoGames',
};
export type PromotionQualificationType = typeof PromotionQualificationType[keyof typeof PromotionQualificationType];
